import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { hoverLighten } from '../../utilities/color-util';
import { Button as OLButton } from '../Buttons/Button/Button';
import { BREAKPOINT_DESKTOP, BREAKPOINT_MOBILE } from '../Style/breakpoints';
import { OL_COLOUR_CTA_PINK, OL_HOVER_LIGHTEN_AMOUNT } from '../Style/colours';
import { SNACKBAR_Z_INDEX } from '../Style/zindex';
import { SnackBarButtonProps } from './types';

const fadeIn = keyframes({
  '0%': {
    transform: 'translateY(30%)',
    opacity: 0,
  },
  '100%': {
    transform: 'translateX(0)',
    opacity: 1,
  },
});

export const SnackBarComponent = styled('div')({
  animation: `${fadeIn} .3s ease-in-out`,

  position: 'fixed',
  bottom: 60,
  left: 0,
  right: 0,

  display: 'flex',
  flexDirection: 'row',
  maxWidth: BREAKPOINT_DESKTOP,
  width: 'calc(100% - 20px)',
  minHeight: 48,
  margin: '0 auto',
  boxSizing: 'border-box',

  background: '#202020',
  color: '#FFFFFF',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 8,
  fontSize: 14,
  // make sure snackbar always on top of other elements
  zIndex: SNACKBAR_Z_INDEX,

  boxShadow:
    '0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)',

  [`@media only screen and (max-width: ${BREAKPOINT_MOBILE})`]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    padding: 10,
    bottom: 10,
  },
});

export const Text = styled('div')({
  flexShrink: 1,
  a: {
    color: '#FFFFFF',
    textDecoration: 'underline',
    fontWeight: 600,

    ':hover': {
      color: '#FFFFFF',
    },
  },
});

export const Buttons = styled('div')({
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'row',
  marginLeft: 20,

  // gap between buttons
  '*:not(:first-child)': {
    marginLeft: 20,
  },

  [`@media only screen and (max-width: ${BREAKPOINT_MOBILE})`]: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'flex-start',

    marginTop: 20,
    marginLeft: 0,

    '*:not(:first-child)': {
      marginLeft: 0,
    },
  },
});

export const Button = styled(OLButton)<SnackBarButtonProps>(
  ({ primary = false }) => ({
    'button.btn': {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: primary ? OL_COLOUR_CTA_PINK : '#FFFFFF',
      background: primary ? OL_COLOUR_CTA_PINK : 'none',
      color: '#FFFFFF',
      fontSize: 14,
      fontWeight: primary ? 700 : 'normal',
      borderRadius: 4,
      padding: '0.5em 1em',
      cursor: 'pointer',

      '&:hover': {
        color: '#FFFFFF',
        background: primary
          ? hoverLighten(OL_COLOUR_CTA_PINK)
          : `rgba(255, 255, 255, ${OL_HOVER_LIGHTEN_AMOUNT})`,
        borderColor: primary ? hoverLighten(OL_COLOUR_CTA_PINK) : '#FFFFFF',
      },
    },
  })
);
